import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {Link} from 'gatsby';

function Harness(props) {
    return (
        <section className="tekrevol_light_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="AZURE Benefits">
                            <h2>MS Azure Consulting Services To Build Flexible Ecosystems Of Data</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol’s MS Azure Consulting services are designed to help future-oriented businesses build scalable data infrastructure on the MS Azure cloud. Our fail-proof cloud architecture design combined with comprehensive cloud integrations enable clients to achieve the highest performance and efficiency standards and considerably reduce infrastructure costs.</p>

                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Harness;